import config from '../config.json';

export const permissionsServiceApiFactory = (
    httpServiceApi
) => {
    const baseUrl = config.PERMISSIONS_API_URL;

    let response = {};

    const onFailure = error => {
        response.error = error;
    };

    const getUserPermissions = async () => {
        response.permissions = await httpServiceApi.sendRequest(
            `${baseUrl}/user-permissions`,
            null,
            {
                onFailure
            }
        );
        return response;
    };

    return {
        getUserPermissions
    }
};